import { render } from "./PatientList.vue?vue&type=template&id=b223da62&scoped=true"
import script from "./PatientList.vue?vue&type=script&lang=js"
export * from "./PatientList.vue?vue&type=script&lang=js"

import "./PatientList.vue?vue&type=style&index=0&id=b223da62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b223da62"]])

export default __exports__